// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__20BdB","choiceBoxes":"toolbarselects_choiceBoxes__3mC2D","simpleField":"toolbarselects_simpleField__1V6sy"};